module.exports = __webpack_public_path__ + "img/logo-120x120.369d3302.png";